import { useEffect, useState } from 'react';
import DatagridReports from './DataGridReports';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import DatagridFeedback from './DataGridFeedback';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Reports = () => {
  const [currentTab, setcurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setcurrentTab(newValue);
  };

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            aria-label="basic tabs example"
          >
            <Tab label="REPORTS" {...a11yProps(0)} />
            <Tab label="FEEDBACK" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={currentTab} index={0}>
          <DatagridReports />;
        </CustomTabPanel>
        <CustomTabPanel value={currentTab} index={1}>
          <DatagridFeedback />
        </CustomTabPanel>
      </Box>
    </>
  );
};

export default Reports;
